import { mapGetters } from 'vuex';
import mvtPopSignin from '@/common/components/mvtpopsignin/mvt-popsignin.vue';
import ThumbtackResultsList from '../components/thumbtackresultslist/thumbtackresultslist.vue';
import ThumbtackSearch from '../components/thumbtacksearch/thumbtacksearch.vue';
import mvtInputGeo from '@/common/components/mvtinputgeo/mvt-inputgeo.vue';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import { router } from '../../common/utilities/nojq/_router.js';
const isSSR = typeof window === 'undefined';

export default {
    name: 'homeservicesSearch',
    inject: ['$eventBus'],
    components: {
        mvtPopSignin,
        mvtDialogCenter,
        ThumbtackResultsList,
        ThumbtackSearch,
        mvtInputGeo,
        mvtHeader,
        mvtFooter,
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        searchResultTerm() {
            return this.$route.query.query || null;
        },
        utmParam() {
            return (!isSSR && window.location.search.split('&').find((item) => item.includes('utm_content'))) || '';
        },
    },
    data() {
        return {
            hasSearched: false,
            isLoading: false,
            search: {
                query: null,
                zipCode: null,
                utm_medium: null,
                utm_campaign: null,
                utm_source: null,
            },
            providers: [],
            geoInfo: {
                text: '',
                geo: null,
            },
            popularSearches: [
                {
                    title: 'TV Mounting',
                    image: 'tv-mounting@2x.jpg',
                    search: 'tv mounting',
                },
                {
                    title: 'Movers',
                    image: 'movers@2x.jpg',
                    search: 'movers',
                },
                {
                    title: 'House Cleaning',
                    image: 'house-cleaning@2x.jpg',
                    search: 'house cleaning',
                },
                {
                    title: 'Junk Removal',
                    image: 'junk-removal@2x.jpg',
                    search: 'junk removal',
                },
            ],
            topCategories: [
                {
                    title: 'Plumbing',
                    image: 'plumbing.jpg',
                    search: 'plumbing',
                },
                {
                    title: 'Heating & Cooling',
                    image: 'heating-cooling.jpg',
                    search: 'heating and cooling',
                },
                {
                    title: 'Roofing',
                    image: 'roofing.jpg',
                    search: 'roofing',
                },
                {
                    title: 'Landscaping',
                    image: 'landscaping.jpg',
                    search: 'landscaping',
                },
                {
                    title: 'Electrical',
                    image: 'electrical.jpg',
                    search: 'electrical',
                },
                {
                    title: 'Carpentry',
                    image: 'carpentry.jpg',
                    search: 'carpentry',
                },
                {
                    title: 'Concrete & Masonry',
                    image: 'concrete-masonry.jpg',
                    search: 'concrete and masonry',
                },
                {
                    title: 'Drywall & Insulation',
                    image: 'drywall-insulation.jpg',
                    search: 'drywall and insulation',
                },
                {
                    title: 'Flooring',
                    image: 'flooring.jpg',
                    search: 'flooring',
                },
                {
                    title: 'Windows & Doors',
                    image: 'windows-doors.jpg',
                    search: 'windows and doors',
                },
            ],
        };
    },
    methods: {
        async searchPros(query, zipCode) {
            this.isLoading = true;
            this.hasSearched = true;

            try {
                const response = await fetch(`${this.glb.appUrl}api/homeservices/pros/?zip_code=${this.search.zipCode}&category=${this.search.query}`);
                this.providers = await response.json();
            } catch (e) {
                this.providers = [];

                console.log('Could not find results.');
                console.log(e);
            }

            this.isLoading = false;
        },
        getSearchURL(category) {
            let url = `${this.glb.appUrl}homeservices/search/?query=${encodeURIComponent(category.search)}${this.search.zipCode ? '&zip_code=' + this.search.zipCode : ''}`;
            return this.appendUTMParams(url);
        },
        appendUTMParams(url) {
            if (this.search.utm_medium) {
                url += `&utm_medium=${this.search.utm_medium}`;
            }
            if (this.search.utm_campaign) {
                url += `&utm_campaign=${this.search.utm_campaign}`;
            }
            if (this.search.utm_source) {
                url += `&utm_source=${this.search.utm_source}`;
            }
            if (this.search.utm_source) {
                url += `&utm_source=${this.search.utm_source}`;
            }
            if (this.utmParam) {
                url += `&${this.utmParam}`;
            }
            return url;
        },
        onSubmit() {
            this.searchPros(this.search.query, this.search.zipCode);
            let url = '/homeservices/search/?query=' + this.search.query + '&zip_code=' + this.search.zipCode;
            router.add(this.$options.name, this.appendUTMParams(url));
            // this.$router.push("/homeservices/search/?query=" + this.search.query + "&zip_code=" + this.search.zipCode);
        },
    },
    mounted() {
        const query = this.$route.query.query;
        let zipCode = this.$route.query['zip_code'];
        zipCode = zipCode ? parseInt(zipCode) : zipCode;

        if (this.glb.homeservices && this.glb.homeservices.zipCode) {
            this.search.zipCode = this.glb.homeservices.zipCode;
        }

        if (query) {
            this.search.query = decodeURIComponent(query);
        }

        if (zipCode) {
            this.search.zipCode = decodeURIComponent(zipCode);
        }

        if (query && (zipCode || this.search.zipCode)) {
            this.searchPros(query, this.search.zipCode);
        }

        this.search.utm_medium = this.$route.query.utm_medium || null;
        this.search.utm_campaign = this.$route.query.utm_campaign || null;
        this.search.utm_source = this.$route.query.utm_source || null;
    },
    watch: {
        geoInfo(newVal) {
            if (newVal) {
                this.$eventBus.$emit('eventbus-claimed-home', newVal);
            }
        },
    },
};
